<template>
  <ul class="obituary-threaded-comments__single-actions">
    <li>
      <like-comment-action :comment="comment" :small="true" />
    </li>

    <template v-if="createdCommentsItem">
      <li>
        <button
          class="btn icon small"
          type="button"
          @click.prevent="editComment"
        >
          <span v-text="texts.common.edit" />
        </button>
      </li>

      <li>
        <button
          class="btn icon small"
          type="button"
          @click.prevent="deleteComment"
        >
          <span v-text="texts.common.delete" />
        </button>
      </li>
    </template>

    <li class="report-action" v-if="!(createdCommentsItem || attached)">
      <button
        class="btn icon small"
        type="button"
        @click.prevent="reportComment"
      >
        <span v-text="texts.common.report" />
      </button>
    </li>
  </ul>
</template>

<script>
  import { useIsMobile } from "Main/composables/useIsMobile";
  import { mapActions, mapState } from "vuex";
  import LikeCommentAction from "../LikeCommentAction.vue";

  export default {
    components: {
      LikeCommentAction,
    },

    computed: {
      ...mapState("comments", ["createdComments"]),

      createdCommentsItem() {
        if (!this.hasCreatedComments) {
          return null;
        }

        const [item] = this.createdComments.filter(
          (storedItem) => storedItem.id === this.comment.id
        );

        if (!item) {
          return null;
        }

        return item;
      },

      hasCreatedComments() {
        return !!this.createdComments.length;
      },

      hash() {
        if (this.createdCommentsItem) {
          return this.createdCommentsItem.hash;
        }

        return "";
      },
    },

    data() {
      return {
        texts: lavendlaObituary,
      };
    },

    methods: {
      ...mapActions({
        delete: "comments/deleteObituaryComment",
        openDeleteModal: "threadedComments/openDeleteModal",
        openEditModal: "threadedComments/openEditModal",
        report: "comments/reportObituaryComment",
      }),

      deleteComment() {
        this.openDeleteModal({
          comment: this.comment,
          hash: this.hash,
          parent: this.parent,
        });
      },

      editComment() {
        this.openEditModal({
          comment: this.comment,
          hash: this.hash,
          parent: this.parent,
        });
      },

      reportComment() {
        // biome-ignore lint/suspicious/noAlert: native confirm until the page has its own dialog
        const confirmed = confirm(this.texts.moreCommentActions.areYouSure);

        if (confirmed) {
          this.reportCommentAction();
        }
      },

      reportCommentAction() {
        const data = {
          id: this.comment.id,
          parentId: this.parent.id,
        };

        this.report(data).catch((error) => {
          if (error.serverMessage) {
            // biome-ignore lint/suspicious/noAlert: no in-page error UI exists for this form yet
            alert(error.serverMessage);
          } else {
            // biome-ignore lint/suspicious/noAlert: no in-page error UI exists for this form yet
            alert(this.texts.threadedComments.reportError);
          }
        });
      },
    },
    name: "ThreadedCommentsSingleActions",

    props: {
      attached: {
        default: false,
        type: Boolean,
      },
      comment: {
        required: true,
        type: Object,
      },
      parent: {
        default: null,
        type: Object,
      },
    },

    setup() {
      const { isMobile, isTablet } = useIsMobile();
      return { isMobile, isTablet };
    },
  };
</script>
